import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks";
import { colors } from "../../ui/color";
import { EyeIcon } from "../../ui/icons/eyeIcon";
import { EyeOffIcon } from "../../ui/icons/eyeOffIcon";
import { Logo } from "../../ui/icons/logo";
import { InputComponent } from "../../ui/molecoles/input";
import { login, setEmail, setPassword } from "./slice";

export function Login() {
    const dispatch = useAppDispatch()
    const loginState = useAppSelector(state => state.login)

    const navigation = useNavigate()

    const [bool, setBool] = useState(false)

    useEffect(() => {
        if (loginState.loginStatus === "successfully") {
            navigation("/verify")
        }
    }, [loginState.loginStatus])

    return (
        <div className="w-full h-screen flex justify-between items-center">
            <div className="w-[60%] h-full flex items-center justify-center">
                <img
                    src={`${process.env.PUBLIC_URL}/img/background.jpg`}
                    alt="Background"
                    className="h-full w-full object-cover rounded-tr-[40px] rounded-br-[40px]"
                />
            </div>
            <div className="w-[40%] flex items-center flex-col gap-10">
                <Logo />
                <div className="flex flex-col items-center gap-3 w-[50%]">
                    <InputComponent
                        label={"Email"}
                        type={""}
                        placeholder="Inserisci la email"
                        value={loginState.loginRequest.email}
                        onChangeText={(value) => dispatch(setEmail(value))}
                    />
                    <InputComponent
                        label={"Password"}
                        type={bool ? "text" : "password"}
                        placeholder="Inserisci la password"
                        value={loginState.loginRequest.password}
                        onChangeText={(value) => dispatch(setPassword(value))}
                        onClickEndIcon={() => setBool(bool ? false : true)}
                        endIcon={bool ? <EyeIcon size={20} color={colors.neutral[500]} /> : <EyeOffIcon size={20} color={colors.neutral[500]} />}
                    />
                </div>
                <button
                    className="h-[48px] w-[40%] rounded-[40px] py-4 bg-[#222222] text-white flex items-center justify-center"
                    onClick={() => dispatch(login(loginState.loginRequest))}
                >
                    Accedi
                </button>
                {
                    loginState.loginStatus === "failed" &&
                    <span className="text-text-sm text-red-500 font-semibold">
                        Email o password errati
                    </span>
                }
            </div>
        </div>
    )
}